export default __webpack_public_path__ + "static/media/rain-on-roof.75a03936.ogg";